import { t } from '@lingui/macro';

const formatInputContent = (input) => {
  try {
    const baseInput = input;
    const firstKey = Object.keys(input)[0];
    const formattedHeader = {};

    if (input[firstKey] && input[firstKey].Headers) {
      const baseHeaders = input[firstKey].Headers;

      baseHeaders.forEach((item) => {
        formattedHeader[item[0]] = item[2] ? t`Encrypted` : item[1];
      });

      baseInput[firstKey].Headers = formattedHeader;
    }

    return baseInput;
  } catch {
    return input;
  }
};

export default formatInputContent;
